import { Component, Input, OnInit } from '@angular/core';
import { Product, ProductScope, ProductService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import {
  CustomCmsEventService
} from "src/app/spartacus/features/tracking/custom-events/checkout/cms/custom-cms-event.service";

@Component({
  selector: 'app-custom-ohgar-tabs-item',
  templateUrl: './custom-ohgar-tabs-item.component.html',
  standalone: false
})
export class CustomOhgarTabsItemComponent implements OnInit {
  @Input() item: any;
  products$: Observable<Observable<Product>[]>;

  protected readonly PRODUCT_SCOPE = ProductScope.DETAILS;

  constructor(
    protected productService: ProductService,
    private customCmsEventService: CustomCmsEventService,
  ) {
  }

  ngOnInit(): void {
    this.products$ = this.getProducts();
  }

  getProducts(): Observable<Observable<Product>[]> {
    const products: Observable<Product>[] = [];

    [this.item?.product1, this.item?.product2, this.item?.product3, this.item?.product4].forEach((code: string) => {
      if (typeof code === 'string' && code) {
        products.push(this.productService.get(code, this.PRODUCT_SCOPE));
      }
    });

    return of(products);
  }

  handleClick(item) {
    const target = [item];
    this.customCmsEventService.dispatchSelectPromotionEvent(target);
  }
}
